/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Modal, Spin, message } from "antd";
import { ModalChild } from "./ModalChild";
import { handleSignatureCompletion, makeAllFieldsDisabled } from "../features/helperFunctions";
import axios from "axios";
import { DateTime } from "luxon";
import { contractStoreHandle } from "../../ContractStore/state/actions";
import styles from "../styles/HandleSignatureBox.module.css";
import { createOfferContractTypes, createOfferInitialState, listingContractTypes, otherDocsContractTypes } from "../../Common/commondata/commonData";
import { isAtleastOneClientPresent } from "../../OfferTable/utils/helper";
import { useDispatch } from "react-redux";
const ipURL = process.env.REACT_APP_GET_IP_URL;
const ipURLKey = process.env.REACT_APP_GET_IP_URL_KEY;

function HandleSignatureBox({ modalState, setModalState, contractAuthKey, currentUrlId, rootDocData }) {
  const dispatch = useDispatch();
  const { event } = modalState || {};
  const counterProposalExist = rootDocData?.counterProposalExist;
  const [signatureModalState, setSignatureModalState] = useState({
    step: counterProposalExist ? "signConfirm" : "confirm",
    ipData: {},
  });

  const { step, ipData } = signatureModalState;

  const closeModalWithError = (msg) => {
    message.error(msg);
    setModalState({ ...createOfferInitialState });
    return null;
  };

  if (!rootDocData) {
    setModalState({ ...createOfferInitialState });
    return null;
  }

  if (rootDocData?.offerData?.sellingStatus === "HOLD") {
    if (rootDocData?.openFor === "SELLER_AGENT") {
      return closeModalWithError(`This offer has been kept on hold. To enable signing please change status back to In-Progress for this offer from the Offer management dashboard.`);
    } else {
      return closeModalWithError(`This offer has been kept on hold. Please contact seller agent for more details.`);
    }
  }

  const { contractType, RTDInitiator, signatureSequence, openFor } = rootDocData;
  let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};

  if (contractType) {
    const buyerInfo = localData["Buyers"];
    const sellerInfo = localData["Sellers"];
    if (RTDInitiator === "BUYER") {
      if (signatureSequence?.buyer && !isAtleastOneClientPresent(buyerInfo)) {
        const contractTypeMap = {
          CB_SAEFPT: "branch manager",
        };
        const requiredParty = contractTypeMap[rootDocData?.contractType] || "buyer";
        return closeModalWithError(`At least one ${requiredParty} is required in order to sign the document.`);
      }
      if (["SELLER", "SELLER_AGENT"].includes(openFor) && signatureSequence?.seller && !isAtleastOneClientPresent(sellerInfo)) {
        return closeModalWithError(`At least one seller is required in order to sign the document.`);
      }
    }

    if (RTDInitiator === "SELLER") {
      if (signatureSequence?.seller && !isAtleastOneClientPresent(sellerInfo)) {
        const contractTypeMap = {
          ERTL: "landlord",
          ETCT: "tenant",
          CB_SAEFPT: "branch manager",
        };
        const requiredParty = contractTypeMap[rootDocData?.contractType] || "seller";
        return closeModalWithError(`At least one ${requiredParty} is required in order to sign the document.`);
      }
      if (!["SELLER", "SELLER_AGENT", "TITLE_COMPANY"].includes(openFor) && signatureSequence?.buyer && !isAtleastOneClientPresent(buyerInfo)) {
        return closeModalWithError(`At least one buyer is required in order to sign the document.`);
      }
    }

    if (createOfferContractTypes.includes(contractType)) {
      if (!localData["ClosingDate"] || isNaN(new Date(localData["ClosingDate"]).getTime())) {
        return closeModalWithError(`Please enter Closing Date in table 3.1 in order to sign the document.`);
      }
    }
    // Logic to throw error for "ERTB", "ERTS", "ERTL", "ETCT" doc if agent has not added starting date and expiry date
    if ([...listingContractTypes, "ERTB", "CB_ERTB", "ERTL", "ETCT"].includes(contractType) && (!localData["ListingPeriodBeginDate"] || !localData["ListingPeriodEndByDate"])) {
      return closeModalWithError(`Please enter Listing Period in section ${listingContractTypes.includes(contractType) ? "3.7" : "3.6"} in order to sign the document.`);
    }
    // Throw error if user trying to sign without address
    if (listingContractTypes.includes(contractType) && !localData["FullAddress"]) {
      return closeModalWithError(`Please enter full address in order to sign the document.`);
    }
  }

  let handleCancel = () => {
    setModalState({ ...createOfferInitialState });
  };

  let handleOk = () => {};

  const handleYesButtonClick = async () => {
    if (step === "signConfirm") {
      setSignatureModalState({ step: "confirm", ipData: {} });
      return;
    }
    if (step === "confirm") {
      setSignatureModalState({ step: "loading", ipData: {} });
      try {
        const response = await axios.get(`${ipURL}${ipURLKey}`);
        setSignatureModalState({ step: "sign", ipData: response.data });
      } catch (error) {
        setSignatureModalState({ step: "sign", ipData: {} });
      }
    }
  };

  const saveFunc = (signCanvas, destination, initial) => {
    let canvasImage = destination === "text" ? signCanvas : signCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    let timeStamp = DateTime.now().toMillis();
    const signerId = event?.target?.getAttribute("data-signerId");
    const signerKey = event?.target?.getAttribute("data-signerKey");
    const labelType = event?.target?.getAttribute("data-signer-labelType");

    // adding signature data for respective openFor users
    let signatureBlock = {
      ip: typeof ipData === "object" ? ipData : {},
      ...(signerKey ? { key: signerKey } : { key: signerId }),
      ...(labelType ? { labelType } : {}),
      ...(rootDocData.openFor !== "TITLE_COMPANY" ? { _id: signerId } : { key: rootDocData.email }),
      roleType: [...otherDocsContractTypes,"WY_RLC"].includes(rootDocData?.contractType) && ["BUYER_AGENT", "SELLER_AGENT"].includes(rootDocData?.openFor) ? rootDocData?.RTDInitiator : rootDocData?.openFor,
      sign: canvasImage,
      timeStamp: timeStamp,
      initials: initial,
    };
    //   console.log("inside this signature block", signatureBlock);
    handleSignatureCompletion({signatureBlock});
    handleCancel();
    if (rootDocData.openFor === "TITLE_COMPANY") {
      let getData = JSON.parse(localStorage.getItem(currentUrlId));
      localStorage.setItem(currentUrlId, JSON.stringify({ ...getData, TitleCompanySignedBy: rootDocData.fullName }));
    }
    dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey, signatureBlock, valueObj: rootDocData.openFor === "TITLE_COMPANY" ? { TitleCompanySignedBy: rootDocData.fullName } : {} }));
    // All fields disabled logic
    if (currentUrlId && rootDocData) {
      makeAllFieldsDisabled(currentUrlId, rootDocData);
    }
  };
  return (
    <Modal className={styles.signatureConfirmModal} visible={true} onOk={handleOk} mask={true} closable={true} okText={"Submit"} onCancel={handleCancel} footer={false}>
      <div>
        {step === "loading" && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "230px",
            }}
          >
            <Spin tip="Fetching your IP and location..." size="large" />
          </div>
        )}
        {(step === "confirm" || step === "signConfirm") && (
          <div className={styles.confirmIPDivContents}>
            <div className={styles.contentItems}>
              <div>
                <ExclamationCircleOutlined
                  style={{
                    color: "orange",
                    fontSize: "25px",
                    marginTop: "5px",
                  }}
                />
              </div>
              <div>
                <h3 style={{ fontSize: "15px" }}>{step === "signConfirm" ? "There is already a Counterproposal created for this transaction. Are you sure you want to sign this offer?" : "This is a legally binding contract and your signature will be embedded into this document."}</h3>
                {step === "signConfirm" && (
                  <div
                    style={{
                      marginTop: "10px",
                      color: "#b00020",
                      backgroundColor: "#ffe6e6",
                      padding: "10px",
                      borderRadius: "4px",
                      border: "1px solid #b00020",
                    }}
                  >
                    <strong>Note:</strong> It is highly recommended to discuss this with your broker before signing.
                  </div>
                )}
                {/* {step === "signConfirm" && <h4 style={{ marginTop: "10px", color: "red", textDecoration: "underline" }}> Note: It is highly recommended to discuss this with your broker before signing.</h4>} */}
                {step === "confirm" && <h4 style={{ marginTop: "10px", color: "#8F8f8f" }}> Note: We are capturing your IP Address and GPS Location for security reasons. Please click on Yes to proceed!</h4>}
              </div>
            </div>
            <div className={styles.confirmButtons}>
              <Button onClick={handleCancel}>No</Button>
              <Button type="primary" onClick={handleYesButtonClick}>
                Yes
              </Button>
            </div>
          </div>
        )}
        {step === "sign" && (
          <div id="signModalChild" className={styles.addSignModal}>
            <ModalChild evnt={event} currentUrlId={currentUrlId} saveFunc={saveFunc} rootDocData={rootDocData} />
          </div>
        )}
      </div>
    </Modal>
  );
}

export default HandleSignatureBox;
